import react, { useEffect, FC } from 'react';

interface Props {
  items: Array<ListItem>;
  title: string;
}

interface ListItem {
  text: string;
}

export const List: FC<Props> = (props) => {
  const { title, items } = props;

  return (
    <div className="list">
      <h3 className="list__headline">{title}</h3>
      <ul className="list__container">
        {items.map((item, key) => {
          return (
            <li key={key} className="list__item">
              {item.text}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
